import { NgModule } from '@angular/core';
import { NgOptionHighlightDirective } from '@ng-select/ng-option-highlight';

/**
 * Adapter module to keep the previous NgOptionHighlightModule API
 * after the upstream package switched to a standalone directive.
 */
@NgModule({
    imports: [NgOptionHighlightDirective],
    exports: [NgOptionHighlightDirective]
})
export class NgOptionHighlightModule { }
